import { Button, Drawer, Modal, SearchBox, Text } from '@medly-components/core';
import { FilterListIcon } from '@medly-components/icons';
import { FC, type FormEvent } from 'react';

import { useIsMobile } from 'hooks';

import { FilterButton, FiltersWrapper, FooterWrapper } from './FiltersForm.styled';
import type { FiltersFormProps } from './types';

export const FiltersForm: FC<FiltersFormProps> = ({
    id,
    open,
    toggleDrawer,
    onApplyFilters,
    onClearAllFilters,
    searchPlaceholder,
    searchQuery,
    onSearchQueryChange,
    isFiltersApplied,
    children
}) => {
    const isMobile = useIsMobile();
    const Component = isMobile ? Modal : Drawer;
    const Footer = isMobile ? Modal.Actions : Drawer.Footer;

    const handleApplyFilters = (event: FormEvent) => {
        event.preventDefault();
        onApplyFilters(event);
        toggleDrawer();
    };

    return (
        <FiltersWrapper id={id} onSubmit={handleApplyFilters} onReset={onClearAllFilters}>
            <SearchBox
                size="M"
                value={searchQuery}
                placeholder={searchPlaceholder}
                onClear={() => onSearchQueryChange('')}
                onInputChange={onSearchQueryChange}
            />
            <FilterButton onClick={toggleDrawer} isFiltersApplied={isFiltersApplied}>
                <FilterListIcon />
                <Text>Filter</Text>
            </FilterButton>
            <Component open={open} onClose={toggleDrawer} onCloseModal={toggleDrawer} shouldCloseOnOutsideClick={false}>
                <Component.Header>Add Filters</Component.Header>
                <Component.Content>{children}</Component.Content>
                <FooterWrapper>
                    <Footer>
                        <Button variant="outlined" onClick={onClearAllFilters}>
                            Clear All
                        </Button>
                        <Button onClick={handleApplyFilters}>Apply Filters</Button>
                    </Footer>
                </FooterWrapper>
            </Component>
        </FiltersWrapper>
    );
};

FiltersForm.displayName = 'FiltersForm';
